export default __webpack_public_path__ + "static/media/photo--lg--wheel-3.2efe8181.jpg";